export const paths = {
	root: '/manageRoles',
};